import Live from 'pages/live'
import NotFound from 'pages/notFound'
import AccessDenied from 'pages/accessDenied'
import Auth from 'pages/auth'

const publicRoutes = [
  {
    path: '/auth/login',
    page: Auth,
    exact: true
  },
  {
    path: '/auth/renew',
    page: Auth,
    exact: true
  },
  {
    path: '/auth/logout',
    page: Auth,
    exact: true
  },
  {
    path: '/public/:hash',
    page: Live
  },
  {
    path: '/403',
    page: AccessDenied,
    exact: true
  },
  {
    path: '/404',
    page: NotFound,
    exact: true
  },
  {
    path: '/:hash',
    page: Live
  },
  {
    path: '/not_listed/:hash',
    page: Live
  },
  {
    path: '/private/:hash',
    page: Live
  },
  {
    path: '/',
    page: NotFound,
    exact: true
  }
]

export default { publicRoutes }
